import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

function DigilockerClosePage() {
    const location = useLocation();
    const [status, setStatus] = useState('Finalizing Digilocker consent...');
    const [error, setError] = useState('');
    const [requestId, setRequestId] = useState('');

    useEffect(() => {
        let cancelled = false;

        const finalizeKyc = async () => {
            const params = new URLSearchParams(location.search);
            const requestIdFromQuery = params.get('requestId') || params.get('kid') || params.get('request_id');
            const queryConsentId = params.get('consentId') || params.get('consent_id');
            const finalized = params.get('finalized') === '1';
            const session = JSON.parse(localStorage.getItem('userSession') || '{}');
            const token = session?.token || '';
            const userId = session?.userId;
            const apiUrl = process.env.REACT_APP_API_URL || '';
            let requestId = requestIdFromQuery;

            try {
                if (!requestId) {
                    setStatus('Loading Digilocker request...');
                    const statusResponse = await fetch(`${apiUrl}/api/digilocker/status`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token ? { Authorization: `Bearer ${token}` } : {})
                        },
                        body: JSON.stringify({ userId })
                    });
                    const statusJson = await statusResponse.json().catch(() => ({}));
                    const record = statusJson?.record || {};
                    requestId = record.request_id || record.requestId || '';
                    if (!requestId) {
                        throw new Error('Missing Digilocker request id.');
                    }
                }
                if (!cancelled) {
                    setRequestId(requestId);
                }

                if (finalized) {
                    if (!cancelled) {
                        setStatus('Aadhaar fetched successfully. You can close this window.');
                    }
                    return;
                }

                setStatus(`Checking Digilocker consent for ${requestId}...`);
                const statusResponse = await fetch(`${apiUrl}/api/digilocker/status`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...(token ? { Authorization: `Bearer ${token}` } : {})
                    },
                    body: JSON.stringify({ requestId, userId })
                });
                const statusJson = await statusResponse.json().catch(() => ({}));
                const record = statusJson?.record || {};
                const consentId = queryConsentId || record.consent_id || record.consentId || record?.callback_payload?.consentId || null;

                setStatus(`Fetching Aadhaar details for ${requestId}...`);
                const fetchResponse = await fetch(`${apiUrl}/api/digilocker/eaadhaar`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...(token ? { Authorization: `Bearer ${token}` } : {})
                    },
                    body: JSON.stringify({
                        requestId,
                        consentId,
                        userId,
                        callbackPayload: record?.callback_payload || null
                    })
                });
                const fetchJson = await fetchResponse.json().catch(() => ({}));
                if (!fetchResponse.ok || !fetchJson.success) {
                    throw new Error(fetchJson.message || 'Unable to fetch Aadhaar details');
                }

                if (!cancelled) {
                    setStatus('Aadhaar fetched successfully. Returning...');
                    setTimeout(() => {
                        if (window.opener && window.opener !== window) {
                            window.close();
                        }
                    }, 800);
                }
            } catch (err) {
                if (!cancelled) {
                    setError(err.message || 'Failed to finalize Digilocker.');
                    setStatus('Digilocker finalization failed.');
                }
            }
        };

        finalizeKyc();

        return () => {
            cancelled = true;
        };
    }, [location.search]);

    return (
        <div style={{
            minHeight: '100vh',
            display: 'grid',
            placeItems: 'center',
            background: '#f4f9ff',
            color: '#1e293b',
            padding: '2rem',
            textAlign: 'center'
        }}>
            <div style={{
                background: 'white',
                border: '1px solid #cfe4fa',
                borderRadius: '18px',
                padding: '2rem',
                boxShadow: '0 10px 30px rgba(7,85,217,0.10)',
                maxWidth: '420px'
            }}>
                <div style={{ fontSize: '2rem', marginBottom: '0.75rem' }}>🏦</div>
                <h1 style={{ margin: 0, fontSize: '1.3rem' }}>Digilocker completed</h1>
                {requestId && (
                    <p style={{
                        margin: '0.5rem 0 0',
                        fontSize: '0.78rem',
                        color: '#0755d9',
                        fontWeight: 700,
                        wordBreak: 'break-all'
                    }}>
                        Request ID: {requestId}
                    </p>
                )}
                <p style={{ margin: '0.75rem 0 0', color: '#64748b' }}>{status}</p>
                {error && (
                    <p style={{ margin: '0.75rem 0 0', color: '#dc2626' }}>{error}</p>
                )}
            </div>
        </div>
    );
}

export default DigilockerClosePage;
